const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		roleOptionScope: 'protocol',
	},

	model: {
		resourceFilters: {
			// filters: {}
		}
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(fieldType === 'refresh'){
						self.refreshData()
					}
				}
			}
		}
	},

	methods: {

		onFilterChanged: function(filters, preventRefresh, forceRefresh){
			var isEqual = utils.isEqual(this.model.resourceFilters.filters, filters);
			if(forceRefresh || (!preventRefresh && !isEqual)){
				this.model.resourceFilters.filters = utils.simpleCopy(filters || {});
				this.refreshData();
			}
		},

		refreshData: function(){
			var self = this

			self.performAction('refreshResources')
				.then(function(){
					self.updateCharts()
				})
				.fail(function(error){
					// TODO: error handling?
					console.log(error)
				})
			;
		},

		updateCharts: function(){
			this.triggerFind('update', { resourceData: this.resourceData, resourceFilters: this.model.resourceFilters }, 'templates_protocol_stats_chart')
		},

		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
			if(utils.collectionSize(this.model.resourceFilters) > 0){
				resourceFilters = resourceFilters || {};
				utils.refReplace(resourceFilters, this.model.resourceFilters);
			}
			if(actionKey === 'refreshResources'){
				this.model.resourceFilters = resourceFilters || {};
				this.sanitizeResourceFilters(storage, resourceFilters, actionKey);
			}

			return resourceFilters;
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {};
				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		// loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
		// 	var nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
		// 	return actionKey !== 'refreshResources' || nrOfFilters > 0
		// },
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				this.updateCharts()
			}
		}
	}
}
